// NOTE - @Josh is responsible for these comments and will clean them up next time he makes changes.
// Marketing keep changing their minds and its driving me insane. FOR NOW (17/12/2024):

// /pricing uses marketing-pricing.js
// /global-pricing uses marketing-global-pricing.js. 
// These are separately built files.

// /pricing is built with watch_marketing_pricing
// /global-pricing is built with watch_marketing_global_pricing

// This pricing card is for /pricing only.
import pricing_card from '../../../templates/Marketing/pricing/pricing_card_updated.hbs';

// This hbs template is shared between /pricing and /global-pricing
import compare_plan_content from '../../../templates/Marketing/pricing/compare_plan_content.hbs';

function MarketingPricing(config) {
    var MarketingPricing = {
        // World Specific
        _worldMonthly: {
            ent: "$2,243",
            pilot: "$10,000"
        },
        
        _worldAnnual: {
            ent: '$26,916',
            pilot: "$10,000",
        },

        _countryCode: 'AU',
        _annualPricing: false,
        free_trial_active: false,
        _isUSDLocked: false,

        // Page Content
        oneTimeFeeContent: "<b>*One-time setup fee applies.</b><br />Min. 12 month commitment.</br>No credit card required.",
        oneTimeFeeTooltipTemplate: '<div class="tooltip" role="tooltip" style="margin-top:10px;"><div class="tooltip-inner"></div></div>',

        //Enterprise pricing card specific content
        enterprisePricingCardContent: {
            card_type: 'enterprise',
            card_type_capital: 'Enterprise',
            card_type_title: 'Enterprise',
            plan_description: 'Empower your team with the enterprise-grade platform for unlimited employee stories.',
            plan_cta: "Book a Demo",
            plan_link: "/demo?src=pricing-page-enterprise",
            button_type: 'book-demo',
            negotiation: false,
            pricing_pre_description: "Starting from",
            // pricing: 
            items: [
                {
                    id: "AI_Employee_Story",
                    included: true,
                    content: "AI Employee Story video creation workflow"
                },
                {
                    id: "Career_Site_Engagement",
                    included: true,
                    content: "Career Site, Job Ads, and Social engagement"
                },
                {
                    id: "Brand_Compliance",
                    included: true,
                    content: "Brand compliance and simplified editing tools"
                },
                {
                    id: "Enterprise_Security",
                    included: true,
                    content: "Enterprise security, integrations and management"
                },
                {
                    id: "Customer_Success_Management",
                    included: true,
                    content: "Dedicated Customer Success Management",
                },
            ]           
        },

        pilotPricingCardContent: {
            card_type: 'pilot',
            card_type_capital: 'Pilot',
            card_type_title: 'Pilot',
            plan_description: 'Launch and validate your employee story strategy fast with a fully managed pilot.',
            plan_cta: "Book a Demo",
            plan_link: "/demo?src=pricing-page-pilot",
            button_type: 'book-demo',
            pricing_pre_description: "Once off fee of",
            // pricing: 
            items: [
                {
                    id: "Video_Strategy",
                    included: true,
                    content: "Build your employee story video strategy"
                },
                {
                    id: "Story_Feed",
                    included: true,
                    content: "Generate and share unlimited videos "
                },
                {
                    id: "Managed_Pilot_Program",
                    included: true,
                    content: "Fully managed pilot program and support"
                },
                {
                    id: "Validate_Impact_Candidate_Experience",
                    included: true,
                    content: "Validate the impact and candidate experience"
                },
            ]           
        },

        //Compare Plans Content
        comparePlansContent: [
            {
                content_table_title: "Manage Your Team",
                content_table_rows: [
                    {
                        row_heading: "High Definition Videos",
                        info: "Produce unlimited, fully branded employee-generated videos in high-definition quality.",
                        values: [
                            {
                                text: true,
                                content: "5 per month"
                            },
                            {
                                text: true,
                                content: "Unlimited"
                            },
                            {
                                text: true,
                                content: "Unlimited"
                            }
                        ]
                    },
                    {
                        row_heading: "User Licences",
                        info: "Complete access to the VideoMyJob dashboard and mobile app to create, edit, publish, and track videos.",
                        values: [
                            {
                                text: true,
                                content: "2"
                            },
                            {
                                text: true,
                                content: "10"
                            },
                            {
                                text: true,
                                content: "15"
                            }
                        ]
                    },
                    {
                        row_heading: "Film Only Contacts",
                        info: "Capture videos from employees, hiring managers and others through a simplified process, without needing user licence.",
                        values: [
                            {
                                text: true,
                                content: "5"
                            },
                            {
                                text: true,
                                content: "30"
                            },
                            {
                                text: true,
                                content: "Unlimited"
                            }
                        ]
                    },
                    {
                        row_heading: "Role-based Permissions",
                        info: "Standard role types covering Admin, Producer, and Editor to support your video publishing workflow.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Video Categories",
                        info: "Video tagging upon creation, supporting team alignment and tracking of talent engagement strategies.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Asset Library",
                        info: "Upload re-usable company media such as images and videos, for easy team access during video creation and editing.",
                        values: [
                            {
                                text: false,
                                content: false
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Additional Teams",
                        info: "Purchase additional team account to manage video activity across different business units or regions, and enabling users to switch between teams.",
                        values: [
                            {
                                text: false,
                                content: false
                            },
                            {
                                text: false,
                                content: false
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                ]
            },
            {
                content_table_title: "Stay Brand Compliant",
                content_table_rows: [
                    {
                        row_heading: "Brand Templates",
                        info: "Standardise video branding to company guidelines. Each template includes logo image, colour scheme, and web safe font.",
                        values: [
                            {
                                text: true,
                                content: "1"
                            },
                            {
                                text: true,
                                content: "2"
                            },
                            {
                                text: true,
                                content: "2"
                            }
                        ]
                    },
                    {
                        row_heading: "Top and Tail Branding",
                        info: "Branded intro animation and tail image to ensure consistent and professional style across all videos.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Colour Scheme",
                        info: "Lock down a primary colour for each brand template, applied automatically during video creation.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Font Selection",
                        info: "Select a web safe font for each brand template, applied automatically to video captions created during editing.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "No VideoMyJob Branding",
                        info: "Option to remove 'Powered by VideoMyJob' footer branding from the video tail screen for all videos.",
                        values: [
                            {
                                text: false,
                                content: false
                            },
                            {
                                text: false,
                                content: false
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                ]
            },
            {
                content_table_title: "Manage Video Campaigns",
                new_tag: '<span class="badge beta">NEW</span>',
                content_table_rows: [
                    {
                        row_heading: "Campaign Management",
                        info: "Create content at scale on key topics and themes, by creating campaigns to request videos and collect responses all in one place.",
                        values: [
                            {
                                text: false,
                                content: false
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Questions and Scripts",
                        info: "Provide respondents such as employees or hiring managers with instructions of what to film, using either a question prompt or a script to follow.",
                        values: [
                            {
                                text: false,
                                content: false
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Track Video Responses",
                        info: "Track completion of your campaign, no spreadsheets. See whos completed the filming request and easily send reminders to those pending.",
                        values: [
                            {
                                text: false,
                                content: false
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Review and Edit",
                        info: "Review responses and instantly brand and trim the video in a few clicks - ready to publish, or discard videos that are not suitable.",
                        values: [
                            {
                                text: false,
                                content: false
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                ]
            },
            {
                content_table_title: "Create Great Content",
                content_table_rows: [
                    {
                        row_heading: "Desktop Filming",
                        new_tag: '<span class="badge beta">NEW</span>',
                        info: "Enable everyone to create videos - self-serve from their desktop web browser and webcam, no downloads required.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Script Editor and Library",
                        info: "Create scripts with estimated video length, stored in a central library for access and re-use by all team members.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "On-Screen Teleprompter",
                        info: "Load scripts to an on-screen teleprompter, with option of scrolling with adjustable speed or static view.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Camera Positioning Guides",
                        info: "Visual indicators and guides designed for landscape view, to ensure professional angle and framing while recording.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "One-touch Retakes and Segments",
                        info: "Re-take or restart a recording in a single tap. Film in multiple video segments and merge on the fly.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                ]
            },
            {
                content_table_title: "Make Editing Simple",
                content_table_rows: [
                    {
                        row_heading: "Save Projects",
                        info: "Store in-progress and completed video projects on your mobile device for later completion or re-editing.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Video Collaboration",
                        info: "Send video projects to other team members for remote editing and collaboration.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Video Trimming",
                        info: "Quickly and accurately trim unwanted footage from the start and end of a video in a timeline view.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Text Captions",
                        info: "Reinforce key video messages with editable text captions aligned to brand template settings. Emojis also supported.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Image and Video Overlays",
                        info: "Overlay additional images and video, with adjustable size and position including full screen or picture-in-picture.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Cover Image Generator",
                        info: "Choose from 4 video cover designs with video title and a selected video snapshot, to optimise video click rates.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Automated Subtitle Creation",
                        info: "Generate subtitles from video audio, with built in closed caption review and editing. Improve video engagement and accessibility.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                ]
            },
            {
                content_table_title: "Enhance Your Career Site",
                new_tag: '<span class="badge beta">NEW</span>',
                content_table_rows: [
                    {
                        row_heading: "Simple Install",
                        info: "Easily add your Story Feed onto any career site or web page using the one-time javascript install code.",
                        values: [
                            {
                                text: false,
                                content: false
                            },
                            {
                                text: false,
                                content: false
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Story Feed",
                        info: "Engage candidates with self-serve access to your feed of employee video content to communicate your culture and employer brand story.",
                        values: [
                            {
                                text: false,
                                content: false
                            },
                            {
                                text: false,
                                content: false
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Branding and CTA",
                        info: "Align your Story Feed branding with your career site theme. Including colour scheme, banner image, and custom call to action.",
                        values: [
                            {
                                text: false,
                                content: false
                            },
                            {
                                text: false,
                                content: false
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Tags and Filtering",
                        info: "Make it simple for candidates to explore videos most relevant to them, with filters such as office location, job type and topic.",
                        values: [
                            {
                                text: false,
                                content: false
                            },
                            {
                                text: false,
                                content: false
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Feedback Survey",
                        info: "Measure the candidate experiece and sentiment, based on their engagement with your feed of employee video content. ",
                        values: [
                            {
                                text: false,
                                content: false
                            },
                            {
                                text: false,
                                content: false
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Story Feed Analytics",
                        info: "Track Story Feed engagement and capture new insights, such as open rate, top videos and tags, videos per session, and click-through rate. ",
                        values: [
                            {
                                text: false,
                                content: false
                            },
                            {
                                text: false,
                                content: false
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                ]
            },
            {
                content_table_title: "Reach Your Audience",
                content_table_rows: [
                    {
                        row_heading: "Publishing Control",
                        info: "Three stages of publishing including draft, unlisted, and public to support approval processes and control visibility.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "YouTube and Social Integrations ",
                        info: "Connect directly to YouTube and Facebook for direct to social sharing and improved tracking.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "MP4 Download",
                        info: "Download videos in MP4 format with cover image and subtitles (SRT) files for upload to supporting platforms such as LinkedIn. ",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Embed Code",
                        info: "Use standard HTML video embed code to add videos to your employer branding/career sites and job ads.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Landing Pages With Call-To-Action",
                        info: "Share videos through built-in landing pages with extended description or additional info, and an adjustable call to action button.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Trackable Share Links",
                        info: "Create trackable share links for each landing page to promote through different channels and compare engagement by source.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    }
                ]
            },
            {
                content_table_title: "Measure Video Engagement",
                content_table_rows: [
                    {
                        row_heading: "Video Analytics",
                        info: "See video reach and engagement across social channels, landing page, call-to-actions, and share links in a single performance report. ",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Traffic Sources",
                        info: "Break down video engagement by share links to understand and compare the most effective sources.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Playtime Reporting",
                        info: "Track overall minutes watched, and review video drop-off rates to understand viewer behaviour and improve content quality.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Team Analytics",
                        info: "Access an expanded view of performance through team and creator stats, best performing videos, and category reports.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    
                ]
            },
            {
                content_table_title: "Get Service And Support",
                content_table_rows: [
                    {
                        row_heading: "HelpHub",
                        info: "Online knowledge base containing over 140 articles and videos, supporting teams to create great videos, and use VideoMyJob tech.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Email and Live Chat",
                        info: "Email and Live Chat support available directly to all registered users, for technical support and product queries.",
                        values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                    {
                        row_heading: "Customer Success",
                        info: "Proactive success package, delivered by our video experts to help develop your strategy, optimise the approach, and drive outcomes.",
                        values: [
                            {
                                text: false,
                                content: false
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ],
                        world_values: [
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            },
                            {
                                text: false,
                                content: true
                            }
                        ]
                    },
                ]
            },
        ],

    
        // Content Containers
        pricingCardRow: ".pricing-card-row",
        comparePlanTable: "#compare .pricing-table",

        init: function (config){
            if (config)
            {
                Object.keys(config).forEach(function(key, value) {
                    MarketingPricing[key] = config[key];
                });
            }

            this.initEventListeners();
            this.fetchIpLocation();
        },
        initEventListeners: function() {
            $('body').on('click', ".scroll-to", function(event) {
                var hash = this.hash;
                $('html, body').animate({
                    scrollTop: $(hash).offset().top
                }, 800, function(){
                    window.location.hash = hash;
                });
                event.preventDefault();
                return false;
            });
    
            $('body').on('change', '#billing-period', function(event) {    
                if ($("body").find("#billing-period").prop("checked"))
                {    
                    var label = "Monthly To Annual"
                    
                    this._annualPricing = true;
                }
                else
                {    
                    var label = "Annual to Monthly";

                    this._annualPricing = false;
                }

                dataLayer.push(
                    {
                        'event': 'W-Toggle Click '+label,
                    }
                )
    
                this.renderPricingCards();
                // this.renderComparePlanHeaders();
            }.bind(this))
    
            $("body").on("click", "#accordion h5", function(e) {
                dataLayer.push(
                    {
                        'event': 'W-FAQ Question '+$(this).data("qid")+ ' Click',
                    }
                )
            })
    
            $("body").on("click", ".pricing-plan-btn", function(e) {
                sessionStorage.setItem("pricing-plan", $(this).data("pricing-plan"))
            })
        },
        fetchIpLocation: function() {
            if (this._isUSDLocked)
            {
                this.free_trial_active = false;
            }
            
            this.renderPricingCards();
            this.updateCompareTable();

            this.removeLoadingIndicator();
        },
        removeLoadingIndicator: function() {
            $("body").find(".loading-section").addClass("d-none");
        },
        showLoadingIndicator: function() {
            $("body").find(".loading-section").removeClass("d-none");
        },
        renderPricingCards: function() {
            $("body").find(this.pricingCardRow).empty();
            var pricing = this.calculatePricing();
            var pilotCard = this.pilotPricingCardContent;
            var enterpriseCard = this.enterprisePricingCardContent;

            pilotCard.increment = 'USD <br/>/3 month Pilot';
            pilotCard.pricing = pricing.pilot;
            pilotCard.oneTimeFeeContent = this.oneTimeFeeContent;
            pilotCard.oneTimeFeeTooltipTemplate = this.oneTimeFeeTooltipTemplate;

            enterpriseCard.increment = this._annualPricing ? "USD <br/>/ Year*" : "USD <br/>/ Month*";
            enterpriseCard.pricing = pricing.ent;
            enterpriseCard.oneTimeFeeContent = this.oneTimeFeeContent;
            enterpriseCard.oneTimeFeeTooltipTemplate = this.oneTimeFeeTooltipTemplate;

            $("body").find(this.pricingCardRow).append(pricing_card(pilotCard));
            $("body").find(this.pricingCardRow).append(pricing_card(enterpriseCard));

            $("body").find('[data-toggle="tooltip"]').tooltip();
        },
        // Returns set of pricing applicable to the country code
        calculatePricing: function() {
            if (this._annualPricing)
            {
                return this._worldAnnual;
            }
            else
            {
                return this._worldMonthly;
            }
        },
        updateCompareTable: function() {
            this.renderCompanyPlanContent();
        },
        renderCompanyPlanContent: function() {            
            var companyPlansContent = this.comparePlansContent;
            $("body").find(this.comparePlanTable+" tbody").replaceWith(compare_plan_content({comparePlansContent: companyPlansContent}))
        }
    }

    return MarketingPricing;
}

export {MarketingPricing};